module.exports = __webpack_public_path__ + "img/24.5135c969.png";